"use strict";

exports.__esModule = true;
var _DeviceDataItemsContext = require("./DeviceDataItemsContext");
Object.keys(_DeviceDataItemsContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceDataItemsContext[key]) return;
  exports[key] = _DeviceDataItemsContext[key];
});
var _DeviceDataItemsLoader = require("./DeviceDataItemsLoader");
Object.keys(_DeviceDataItemsLoader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceDataItemsLoader[key]) return;
  exports[key] = _DeviceDataItemsLoader[key];
});